<div class="blank-chart">
    <div class="title-text">{{title}}</div>
    <div *ngFor="let value of values"
         class="value"
         [ngClass]="{'single': values.length === 1, 'secondary': value.secondary}">
        <div class="value-text">{{value.value}}</div>
        <div *ngIf="value.name && values.length > 1" class="value-subtitle">{{value.name}}</div>
    </div>
</div>
